/* Yakishimi — le strict nécessaire : mise à jour du panier sans rechargement complet
   et repli propre si JavaScript est absent (les formulaires Shopify fonctionnent seuls). */
(function () {
  var champs = document.querySelectorAll('.panier__ligne input[name="updates[]"]');
  champs.forEach(function (champ) {
    champ.addEventListener('change', function () {
      var formulaire = champ.closest('form');
      if (formulaire) formulaire.submit();
    });
  });
})();
